<script>
import {markDetail, markScore} from "@/utils/apis"
import common from "../../utils/common";
import TopicAnswerPanel from "../../components/topic/TopicAnswerPanel.vue";
import TopicOptions from "@/components/topic/TopicOptions.vue";
export default {
    data() {
        return {
            query: JSON.parse(localStorage.getItem("query")) || null,
            nickName: "",
            paperName: "",
            submitTime: "",
            tableData: [],
            paperContent: {},
            totalScore: 0,
            headerLabels: {
                single: {label: "单选题", value: 0},
                multiple: {label: "多选题", value: 0},
                judge: {label: "判断题", value: 0},
                fillBlank: {label: "填空题", value: 0},
                askAnswer: {label: "问答题", value: 0},
            },
            showColumn: ["label", "single", "multiple", "judge"],
            columns: [],
            topicLabel: [],
            analysises: [],
            labelIndex: ["一", "二", "三", "四", "五"],
            mark: this.$route.query.mark ? Number(this.$route.query.mark) : 1,
            markData: [],
            maxScoreLimits: [],
        }
    },
    props: {
        id: {type: Number, default: 0}
    },
    components: {
        TopicAnswerPanel,
        TopicOptions,
    },
    created() {

    },
    mounted() {
        console.log("id", this.id)
        this.getPaperInfo();
    },
    methods: {
        submitMarkData() {
            const mark_data = [];
            let msg = null;
            this.markData.map((item, index) => {
                if (Number(item) > Number(this.maxScoreLimits[index])) {
                    msg = "学生单个问答题的得分不能超过问答题分值"
                }
                if (!Number(item) && !item.trim().length) {
                    msg = "还有问答题没有评分"
                }
                mark_data.push(
                    {topic_id: index, score: Number(item)}
                )
            })
            if (msg) {
                this.$message.warning(msg)
                return
            }
            const params = {
                stu_id: this.$route.query.stu_id,
                id: this.$route.query.id,
                mark_data: mark_data
            }
            markScore(params).then(({code, data, msg}) => {
                if (code === 200) {
                    this.$message({
                        type: "success",
                        message: msg,
                        duration: 1500,
                        onClose: () => this.getPaperInfo()
                    })
                } else {
                    this.$message.warning(msg)
                }
            }).catch(err => common.axiosErrorMsg(err))
            console.log("params", params)

        },
        changeAnalysieStatus(id) {
            this.$set(this.analysises, id, !this.analysises[id])
        },
        countTotalScore(list) {
            if (!list.length) return 0;
            return list.map((item) => Number(item.score)).reduce((a, b) => a + b)
        },
        objectSpanMethod({row, column, rowIndex, columnIndex}) {
            if (this.columns.includes(columnIndex)) {
                if (rowIndex === 0 ) {
                    return {
                        rowspan: 4,
                        colspan: 1
                    };
                } else {
                    return { rowspan: 0, colspan: 0}
                }
            }
        },
        getPaperInfo() {
            const query = this.$route.query;
            const params = {
                stu_id: query.stu_id,
                id: query.id ? query.id : this.id,
            }
            markDetail(params).then(({code, data, msg}) => {
                if (code === 200) {
                    // console.log("data", data)
                    this.nickName = data.nickname;
                    this.paperName = data.paperName
                    this.submitTime = data.submit_time;
                    this.paperContent = data.paper
                    let i = 0;
                    for (let key in data.paper) {
                        if (data.paper[key].length > 0) {
                            this.topicLabel[key] = i;
                            this.headerLabels[key]["value"] = data.paper[key].length
                            i++;
                            if (["fillBlank", "askAnswer"].includes(key)) {
                                this.columns.push(i)
                            }
                            if (data.paper[key].length) {
                                data.paper[key].map((item) => {
                                    this.analysises[item.id] = false
                                })
                            }
                        }


                    }
                    this.tableData = data.table
                    console.log("data", data.table)
                    this.totalScore = 0;
                    if (this.tableData.length) {
                        const scoreObject = this.tableData[this.tableData.length - 1];
                        for (let type in scoreObject) {
                            if (Number(scoreObject[type])) {
                                this.totalScore += Number(scoreObject[type])
                            }
                        }
                    }
                    if (this.mark === 2) {
                        this.paperContent = {
                            askAnswer: data.paper["askAnswer"]
                        };
                        const status = Number(data.status)
                        console.log("status", status)
                        data.paper["askAnswer"].map((item) => {
                            this.markData[item.id] = status === 2 ? "" : item.stu_score;
                            this.maxScoreLimits[item.id] = item.score
                        })
                    }
                } else {
                    this.$message.warning(msg)
                }
            }).catch(err => common.axiosErrorMsg(err))
        }
    }
}
</script>
<template>
    <div class="mark-content">
        <div class="breadcrumb-content" v-if="!id">
            <div class="bread">
                <div class="breadcrumb-label">当前位置：</div>
                <el-breadcrumb separator=">">
                    <el-breadcrumb-item>课程</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ query.zhangName }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ query.jieName }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="paper-main">
            <div class="paper-info" :class="mark === 2 ? 'mark' : (id ? 'stu-detail' : '')">
                <div class="paper-header">
                    <div class="paper-base">
                        <div class="paper-name">{{ paperName }}</div>
                        <div class="person">
                            答题人：{{ nickName }} 交卷时间：{{ submitTime }}
                        </div>
                    </div>
                    <div class="paper-status-tag" v-if="mark === 2">
                        <el-button style="width: 82px;background-color: #F01414;" size="small" type="danger" round>批阅中</el-button>
                    </div>
                </div>
                <div class="paper-content">
                    <el-scrollbar style="height: 100%;">
                        <div class="paper-table">
                            <div class="total-score-panel">
                                <div class="score-info">
                                    <div class="icon">
                                        <i class="iconfont">&#xe679;</i>
                                    </div>
                                    <div class="score-list">
                                        <div class="total">总分：100分</div>
                                        <div class="score">得分：{{ totalScore }}分</div>
                                    </div>
                                </div>
                            </div>
                            <div class="score-table">
                                <el-table :data="tableData" border style="width: 100%;" :span-method="objectSpanMethod">
                                    <el-table-column v-for="(value, key) in tableData[0]"
                                            :key="key"
                                            align="center">
                                        <template slot="header" slot-scope="scope">
                                            <span>{{ headerLabels[key] ?  headerLabels[key]["label"] : "" }}</span>
                                            <span style="color:#EAEAEA;">{{ headerLabels[key] ?  `（${headerLabels[key]["value"]}道题）` : ""}}</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <span v-if="showColumn.includes(key)">
                                                {{ scope.row[key] }} {{ key === "label" ? "" : scope.$index === 3  ? "分" : "道" }}
                                            </span>
                                            <span v-if="key === 'fillBlank'">
                                                得分：{{ tableData[tableData.length - 1][key] }}分
                                            </span>
                                            <div style="display: flex;justify-content: center;align-items: center;" v-if="key === 'askAnswer'">
                                                <span>得分：</span>
                                                <el-input style="width: 50px;" :disabled="true" v-model="tableData[tableData.length - 1][key]" />
                                                <span>&nbsp;分</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="topic-list">
                            <div class="topic-type-content" v-for="(topicList, topicType) in paperContent" :key="topicType">
                                <template v-if="topicList.length > 0">
                                    <div class="topic-type-header">
                                        <span v-if="mark === 1">{{ labelIndex[topicLabel[topicType]]}}、</span>
                                        <span>{{ headerLabels[topicType].label }}</span>
                                        <span class="topic-score">(共{{topicList.length}}题，共{{countTotalScore(topicList)}}分)</span>
                                    </div>
                                    <div class="topic-item" v-for="(topic, index) in topicList" :key="index">
                                        <div class="topic-title-content">
                                            <div class="topic-title">
                                                <div class="topic-num">
                                                    <span>{{ index + 1 }}.</span>
                                                </div>
                                                <div class="topic-txt">
                                                    <span class="blue">&nbsp;&nbsp;({{topic.score}}分)&nbsp;&nbsp;</span>
                                                    <span v-html="topic.topic.title"></span>
                                                </div>
                                            </div>
                                            <div class="analysis-btn">
                                                <el-button type="primary" size="small" @click="changeAnalysieStatus(topic.id)">
                                                    题目解析
                                                    <i class="el-icon-arrow-down" v-if="!analysises[topic.id]"></i>
                                                    <i class="el-icon-arrow-up" v-else></i>
                                                </el-button>
                                            </div>
                                        </div>
                                        <div class="topic-option">
                                            <topic-options :topic="topic" />
                                        </div>
                                        <div class="topic-analysis">
                                            <topic-answer-panel :topic="topic" v-if="mark !== 2" />
                                            <div class="mark-answer-panel" v-else>
                                                <div class="stu-answer-tag">
                                                    <el-tag type="danger" style="width: 76px;">学生答案</el-tag>
                                                </div>
                                                <div class="stu-answer-content">
                                                    <div class="answer-detail">{{ topic.stu_answer }}</div>
                                                    <div class="mark-score-input">
                                                        得分&nbsp;&nbsp;<el-input style="width: 120px;"
                                                        v-model="markData[topic.id]"
                                                        placeholder="请输入分数" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="topic-analysis-content" v-if="analysises[topic.id]">
                                            题目解析：{{ topic.topic.analyse && topic.topic.analyse.length > 0  ? topic.topic.analyse : "暂无解析" }}
                                        </div>
                                    </div>
                                </template>

                            </div>

                        </div>

                    </el-scrollbar>
                </div>

            </div>
            <div class="mark-btn-area" v-if="mark === 2">
                <el-button type="primary" @click="submitMarkData">提交批阅</el-button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.mark-btn-area {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
}
.mark-answer-panel {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .stu-answer-tag {
        &:deep(.el-tag--danger) {
            background-color: #FFDFDF;
            color: #FF0000;
        }
    }
    .stu-answer-content {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin-left: 16px;
        .answer-detail {
            padding: 6px 10px 10px 0;
            margin-bottom: 10px;
        }
    }
}
.topic-type-content {
    .blue {
        color: #006EFF;
    }
    .red {
        color: #f01414;
    }
    .bold {
        font-weight: 700;
    }
    margin-top: 20px;
    .topic-type-header {
        margin-bottom: 14px;
        color: #333;
        font-size: 18px;
        font-weight: 600;
        .topic-score {
            font-weight: 500;
            font-size: 16px;
            color: #666666;
        }
    }
    .topic-item {
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid #EAEAEA;
        margin-bottom: 20px;
        .topic-title-content {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .topic-title {
                width: 0;
                flex: 1;
                font-size: 16px;
                color: #333;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .topic-num {
                    width: 20px;
                    height: 20px;
                    line-height: 25px;
                }
                .topic-txt {
                    width: 0;
                    flex: 1;
                    line-height: 25px;
                    p {
                        display: inline;
                    }
                }
            }
            .analysis-btn {
                width: 110px;
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }
        .topic-option {
            width: 100%;
            padding-left: 20px;
        }
        .topic-analysis {
            padding-left: 20px;
            margin-top: 20px;
        }
        .topic-analysis-content {
            width: 100%;
            background-color: #F5F5F5;
            color: #333333;
            border-radius: 5px;
            padding: 10px;
            margin-top: 10px;
        }
    }

}
.mark-content {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    &, & * {
        box-sizing: border-box;
    }
    .breadcrumb-content {
        width: 100%;
        height: 42px;
        background-color: #282828;
        color: #FFF;
        .bread {
            height: 100%;
            margin: 0 100px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &:deep(.el-breadcrumb) {
                .el-breadcrumb__inner {
                    color: #FFF;
                }
            }
        }
    }
    .paper-main {
        width: 100%;
        height: calc(100% - 42px);
        padding: 20px 0;
        .paper-info {
            &.stu-detail {
                width: 100%;
            }
            &.mark {
                height: calc(100% - 120px);
            }
            width: 1200px;
            margin: 0 auto;
            height: 100%;
            border: 1px solid #EAEAEA;
            .paper-header {
                width: 100%;
                height: 80px;
                border-bottom: 1px solid #EAEAEA;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 20px;
                .paper-base {
                    .paper-name {
                        font-size: 16px;
                        color: #333333;
                        font-weight: 500;
                    }
                    .person {
                        color: #666666;
                        font-size: 14px;
                    }
                }
            }
            .paper-content {
                width: 100%;
                height: calc(100% - 80px);
                &:deep(.el-scrollbar) {
                    .el-scrollbar__wrap {
                        overflow-x: hidden;
                    }
                }
                .topic-list {
                    width: 100%;
                    padding: 0 20px;
                }
            }
            .paper-table {
                width: 100%;
                padding: 20px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                border-bottom: 1px solid #EAEAEA;
                .total-score-panel {
                    width: 202px;
                    height: 137px;
                    background: linear-gradient( 270deg, #3A8CF6 0%, #6BC0FF 100%);
                    border-radius: 10px 10px 10px 10px;
                    margin-right: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .score-info {
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        color: #FFF;
                        .icon {
                            width: 50px;
                            height: 50px;
                            background-color: #FFF;
                            border-radius: 10px 10px 10px 10px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-right: 10px;
                            i.iconfont {
                                color: #006EFF;
                                font-size: 18px;
                                font-weight: 500;
                            }
                        }
                        .score-list {
                            font-size: 18px;
                        }
                    }
                }
                .score-table {
                    width: 0;
                    flex: 1;
                }
            }
        }
    }
}
</style>
